var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.display
        ? _c("div", { attrs: { slot: "placeholder" }, slot: "placeholder" }, [
            _c("div", { staticClass: "preparing" }, [
              _c("div", { staticClass: "outer" }, [
                _c(
                  "div",
                  { staticClass: "inner" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._t("loader-message", function () {
                      return [_vm._m(1)]
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : [_vm._t("default")],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-spinner" }, [
      _c("div", { staticClass: "sk-circle1 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle2 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle3 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle4 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle5 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle6 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle7 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle8 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle9 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle10 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle11 sk-circle" }),
      _vm._v(" "),
      _c("div", { staticClass: "sk-circle12 sk-circle" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("h3", [_vm._v("Please wait")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }